<template>
  <section>
    <InputField :form="form" :question="question" />
  </section>
</template>

<script>
export default {
  props: {
    question: {
      type: Object,
      required: true
    },
    form: {
      type: Object,
      required: true
    }
  },
  components: {
    InputField: () => import("./InputField")
  }
};
</script>
